import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJenisUkt } from "@/services/getData"

export default function MasterJenisUktPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenisUkt"],
    queryFn: getListJenisUkt,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
